// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import govEntity from './entities/gov.json';
import govMenu from '../pages/gov/menu.json';
import govFullForm from '../pages/gov/forms/full.json';
import govContextForm from '../pages/gov/forms/context.json';
import govMiniForm from '../pages/gov/forms/mini.json';
import govLookupForm from '../pages/gov/forms/lookup.json';
import govTableView from '../pages/gov/views/table.json';
import govStagesView from '../pages/gov/views/stages.json';
import govCardsView from '../pages/gov/views/cards.json';
import govInlineView from '../pages/gov/views/inline.json';
import govBacklogView from '../pages/gov/views/backlog.json';
import govSplitView from '../pages/gov/views/split.json';
import govCalendarView from '../pages/gov/views/calendar.json';
import govDashboardView from '../pages/gov/views/dashboard.json';

/** Тип запису «Взаємодія з Урядом» зі сторінками пакета: меню, форми та подання з pages/gov/. */
export const govDefinition: IRecordTypeDefinition = {
  ...govEntity,
  views: assembleViewSet({
      table: govTableView,
      stages: govStagesView,
      cards: govCardsView,
      inline: govInlineView,
      backlog: govBacklogView,
      split: govSplitView,
      calendar: govCalendarView,
      dashboard: govDashboardView,
  }),
  form: govFullForm,
  forms: { full: govFullForm, context: govContextForm, mini: govMiniForm, lookup: govLookupForm },
  menu: govMenu,
} as IRecordTypeDefinition;
